import { State } from '../index';
import { se } from 'module/Common';

export namespace MainSelector {
  export const isTouch = (s: State) => se(s, 'touch', s.touch);
  export const isTouchDetected = (s: State) => se(s, 'touchDetected', s.touchDetected);
}



// WEBPACK FOOTER //
// ./src/module/Redux/Main/MainSelector.ts